module.exports = __webpack_public_path__ + "static/media/uideo.1dfb5025.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Uideo/assets/uideo.png
// module id = 71
// module chunks = 0